import { CategoriaIncompativelMessageStrategy } from '../strategies/CategoriaIncompativelMessage'
import { CrescimentoAlturaIncompativelMessageStrategy } from '../strategies/CrescimentoAlturaIncompativelMessage'
import { CrescimentoCapIncompativelMessageStrategy } from '../strategies/CrescimentoCapIncompativelMessage'
import { CrescimentoDapIncompativelMessageStrategy } from '../strategies/CrescimentoDapIncompativelMessage'

export class ValidacaoConsistenciaMessagesFactory {
	static make(inconsistencia) {
		switch (inconsistencia.tipo) {
			case 'CRESCIMENTO_ALTURA_INCOMPATIVEL':
				return new CrescimentoAlturaIncompativelMessageStrategy(
					inconsistencia.valorAnterior,
					inconsistencia.valorAtual,
				)
			case 'CRESCIMENTO_CAP_INCOMPATIVEL':
				return new CrescimentoCapIncompativelMessageStrategy(
					inconsistencia.valorAnterior,
					inconsistencia.valorAtual,
				)
			case 'CRESCIMENTO_DAP_INCOMPATIVEL':
				return new CrescimentoDapIncompativelMessageStrategy(
					inconsistencia.valorAnterior,
					inconsistencia.valorAtual,
				)
			case 'CATEGORIA_INCOMPATIVEL':
				return new CategoriaIncompativelMessageStrategy(
					inconsistencia.valorAnterior,
					inconsistencia.valorAtual,
				)
			default:
				throw new Error(`Tipo de inconsistência desconhecido: ${inconsistencia.tipo}`)
		}
	}
}
